import { RequestOptions } from "./types";

const SERVICES_API_BASE_URL = "https://api.blackbaud.services";

const DEFAULT_HEADERS = {
  accept: "application/json",
};

export const request = async <T>(
  path: string,
  { params, headers, method = "GET", body }: RequestOptions = {},
): Promise<T> => {
  const url = new URL(`${SERVICES_API_BASE_URL}${path}`);

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value != null) {
        url.searchParams.set(key, String(value));
      }
    });
  }

  const fetchOptions: RequestInit = {
    method,
    headers: {
      ...DEFAULT_HEADERS,
      ...headers,
    },
  };

  if (body !== undefined) {
    (fetchOptions.headers as Record<string, string>)["content-type"] =
      "application/json";

    fetchOptions.body = JSON.stringify(body);
  }

  const response = await fetch(url.toString(), fetchOptions);

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }

  return response.json() as Promise<T>;
};
